import MenuService from "../../core/components/menu/MenuService";
import MenuItem from "../../core/components/menu/MenuItem";
import i18n from './../../shared/i18n'
import LiveLotsPerformance from "./LiveLotsPerformance";
import LLPSales from "@/modules/live-lots-performance/LLPSales.vue";

const routes = [
  {
    path: 'llp-sales',
    name: 'llpSales',
    component: LLPSales,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: 'live-lots-performance/:auctionUuid?',
    name: 'liveLotsPerformance',
    component: LiveLotsPerformance,
    meta: {
      requiresAuth: true
    }
  },
];

MenuService.addMenuItem(new MenuItem('/llp-sales', i18n.t('LLP'), 4, 'gavel', [], 'live_lot_performance'));

export {routes}
